import {createContext} from 'react'

export const GlobalState = createContext({})
